import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableHead,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Clear } from "@material-ui/icons";
import { App, Exercises, Workouts } from "app-interfaces";
import i18next from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";
import Popup from "reactjs-popup";

import {
  isScoreTypeWithIntegerValues,
  metricConverter,
  metricUnit,
  useStateValue,
} from "../../config/AppContext";
import {
  CardioScoreCloumns,
  CardioScoreType,
  ExerciseType,
  ScoreType,
  StrengthScoreColumns,
  WorkoutScoreColumns,
  WorkoutScoreType,
} from "../../types/StaticTypes";
import { ConfirmModal as ConfirmCol } from "../Modals";
import Icons from "../Utilities/Icons";

const useStyles = makeStyles((theme) => ({
  addSetBtn: {
    backgroundColor: "#7ed320",
    borderColor: "#7ed320",
  },
  tableToppy: {
    width: "10px",
  },
  tableContainer: {
    margin: "12px 0",
    maxWidth: "100%",
    maxHeight: 560,
    overflow: "auto",
    position: "relative",
    backgroundColor: "var(--text-primary)",
    backgroundSize: "248px",
    "& .MuiTable-root": {
      "& tr": {
        height: 38,
        "& th, & td, ": {
          minWidth: 130,
          // border: '1px solid #ffffff',
          padding: "12px 12px",
          fontSize: 14,
          fontWeight: 500,
          color: "#ffffff",
        },
        "& th:first-child": {
          width: 124,
          borderRight: "1px solid white",
        },
        "& td:first-child": {
          borderRight: "1px solid white",
        },
      },
      "& .MuiTableHead-root": {
        backgroundColor: "var(--text-primary)",
      },
      "& .MuiTableBody-root": {
        // backgroundColor: '#5692F4',
        backgroundColor: "var(--text-primary)",
        "& tr": {
          "& td": {
            paddingTop: 5,
            paddingBottom: 2,
            // verticalAlign: 'top',
            "& .form-label, & .form-control": {
              marginTop: "0px",
              fontSize: 14,
              fontWeight: 500,
              textAlign: "left",
              textTransform: "capitalize",
              marginBottom: "2px",
              "& span": {
                color: "#ffffff",
                // display: 'block',
                marginLeft: "4px",
                textTransform: "lowercase",
              },
            },
            "& .form-label": {
              color: "#ffffff",
            },
            "& .form-control": {
              display: "block",
              width: "100%",
              height: "calc(1.5em + .75em + 2px)",
              padding: ".375rem .75rem",
              color: "#495057",
              backgroundColor: "#ffffff",
              backgroundClip: "padding-box",
              border: "1px solid #ced4da",
              borderRadius: ".25rem",
              transition: "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
            },
          },
        },
      },
    },
  },
  dialog: {
    "& .MuiDialogTitle-root": {
      height: 75,
      backgroundColor: "var(--text-primary)",
      color: "#ffffff",
      fontSize: 20,
      fontWeight: 500,
      padding: "25px 15px",
      "& svg": {
        float: "right",
        marginRight: 15,
        marginTop: -2,
      },
      "& .session-options": {
        float: "right",
        fontSize: 14,
        fontWeight: 400,
        "& li": {
          fontSize: 16,
          fontWeight: "bold",
          padding: "5px 0",
          "& svg": {
            height: 24,
            width: 24,
            marginRight: 14,
          },
        },
      },
    },
    "& .MuiDialogContent-root": {
      "& textarea": {
        marginTop: 15,
        padding: 15,
        borderRadius: 3,
        width: "100%",
        height: 83,
        border: "1px solid #dcdcdc",
        backgroundColor: "transparent",
        fontSize: 16,
      },
    },
    "& .MuiDialogActions-root": {
      paddingLeft: 20,
      paddingRight: 20,
      width: "100%",
      "& button": {
        height: 50,
        backgroundColor: "var(--text-primary)",
        color: "#ffffff",
        fontSize: theme.spacing(2),
        textTransform: "capitalize",
      },
    },
  },
}));

type TableProps = {
  exercise: Workouts.IExercise;
  exerciseItem: Exercises.IExercise;
  currentTab?: number;
  index: number;
};

export default function TableComponent(props: TableProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { exercise, exerciseItem, currentTab, index } = props;
  const { ic_del, ic_info } = Icons;

  const { catalog, metric } = useStateValue() as {
    catalog: App.State["catalog"];
    metric: App.State["metric"];
  };

  const isSchedule = !/workouts/.test(window.location.href);
  const [labelState, setLabelState]: any = React.useState([]);
  const [tableHead, setTableHead] = React.useState<JSX.Element>();
  const [tableBody, setTableBody] = React.useState<JSX.Element[]>();
  const [resultRow, setResultRow] = React.useState<JSX.Element[]>();
  const [targetCol, setTargetCol] = React.useState<number | null>(null);
  const [targetSetNotes, setTargetSetNotes] = React.useState<number | null>(null);
  const [showConfirmCol, setShowConfirmCol] = React.useState(false);
  const [showSetNotes, setShowSetNotes] = React.useState(false);
  const [generateTableCount, setGenerateTableCount] = React.useState(0);

  React.useEffect(() => {
    setTimeout(function () {
      const x = document.getElementById(`table-container-${index}`)?.clientHeight;
      const y = document.getElementById("setTop");
      const z = document.getElementById(`table-container-${index}`)?.clientWidth;
      const stepsIndicator = document.getElementById("setMarginTop");
      // console.log('tablewidth', z)
      if (y && x && window.innerWidth > 700) {
        y.style.top = `${x + 130}px`;
      }
      if (stepsIndicator && x && window.innerWidth > 700) {
        stepsIndicator.style.top = `${x + 150}px`;
        if (z) {
          stepsIndicator.style.width = `${z}px`;
        }
      }
    }, 10);
  });
  // Show confirm rem Col
  const showConfirmColModal = React.useCallback(() => {
    if (!targetCol) return setShowConfirmCol(false);
    return setShowConfirmCol(true);
  }, [targetCol]);
  // Show set note
  const showSetNoteModal = React.useCallback(() => {
    if (!targetSetNotes) return setShowSetNotes(false);
    return setShowSetNotes(true);
  }, [targetSetNotes]);

  // Handle rem set click
  const handleRemCol = (e: MouseEvent) => {
    const currentTarget = e.currentTarget as HTMLSpanElement | null;
    if (currentTarget) {
      const tableHeadCell = currentTarget.parentElement as HTMLTableHeaderCellElement | null;
      return tableHeadCell && setTargetCol(tableHeadCell.cellIndex);
    }
  };
  // Handle set notes click
  const handleSetNotes = (e: MouseEvent) => {
    const currentTarget = e.currentTarget as HTMLSpanElement | null;
    if (currentTarget) {
      const tableHeadCell = currentTarget.parentElement as HTMLTableHeaderCellElement | null;
      return tableHeadCell && setTargetSetNotes(tableHeadCell.cellIndex);
    }
  };

  // Save set notes
  const saveSetNotes = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const formData = new FormData(e.currentTarget);
    const newNotes = formData.get("notes") as string;
    const targetTable = document.getElementById(`set-table-${index}`) as HTMLTableElement | null;
    if (!targetTable || !targetSetNotes) return;
    const tableBody = targetTable.children[1] as HTMLTableElement; // <tbody/>
    const tableBodyRows = tableBody.children as HTMLCollectionOf<HTMLTableRowElement>; // <tr/>
    const tableSetNotes = tableBodyRows[0].children[targetSetNotes].children[1] as HTMLInputElement;
    tableSetNotes.setAttribute("value", newNotes);
    if (!exercise.notes_sets) Object.assign(exercise, { notes_sets: [] });
    exercise.notes_sets[targetSetNotes - 1] = newNotes;
    return setTargetSetNotes(null);
  };
  // Confirm remove column
  const confirmRemCol = () => {
    const targetTable = document.getElementById(`set-table-${index}`) as HTMLTableElement | null;
    const dataInput = document.getElementById("data") as HTMLInputElement | null;
    if (!targetTable || !targetCol || !dataInput) return;

    const tableHead = targetTable.children[0] as HTMLTableElement; // <thead/>
    const tableHeadRow = tableHead.children[0] as HTMLTableHeaderCellElement; // <th/>
    const tableBody = targetTable.children[1] as HTMLTableElement; // <tbody/>
    const tableBodyRows = tableBody.children as HTMLCollectionOf<HTMLTableRowElement>; // <tr/>

    // Remove the head cell.
    tableHeadRow.children[targetCol].remove();
    // Remove coresponding column cells.
    [...tableBodyRows].forEach((v) => v.children[targetCol].remove());

    // Get current exercise
    const currentExercise = exercise;
    // Decrement score count.
    currentExercise.score_count && currentExercise.score_count--;
    // Splice score values.
    currentExercise.score_vals &&
      currentExercise.score_vals.map((val) => val.value.splice(targetCol - 1, 1));
    // Update data input value
    const currentDataInput = JSON.parse(dataInput.value) as Workouts.IExercise[];
    if (currentTab) {
      currentDataInput[currentTab - 1] = currentExercise;
      dataInput.value = JSON.stringify(currentDataInput);
    } else {
      dataInput.value = JSON.stringify([currentExercise]);
    }

    if (targetCol >= 1) {
      for (let i = targetCol; i < tableHeadRow.children.length; i++) {
        tableHeadRow.children[i].innerHTML = `<td>${i}
        <span class='info-icon' onClick='${handleSetNotes}'>
                    <img
                      src='${ic_info}'
                      alt='${t("notes")}'
                      title='${t(`Set ${i + 1} Notes`)}'
                    />
                  </span>
        <span class='del-icon' id='dlt${i + 1}'><img src='${ic_del}'/></span></td>`;
        tableHeadRow.children[i].children[0].addEventListener("click", (e: any) =>
          handleSetNotes(e)
        );
        tableHeadRow.children[i].children[1].addEventListener("click", (e: any) => handleRemCol(e));
      }
    }

    return setTargetCol(null);
  };
  // Generate Metrics
  const generateMetrics = React.useCallback((name: string) => metricUnit(name, metric), [metric]);

  // Generate HeadRow
  const generateHeadRow = React.useCallback(() => {
    const handleRemCol = (e: React.MouseEvent<HTMLSpanElement>) => {
      if (e.currentTarget) {
        const targetRow = e.currentTarget.parentElement as HTMLTableHeaderCellElement | null;
        return targetRow && setTargetCol(targetRow.cellIndex);
      }
    };
    const handleSetNotes = (e: React.MouseEvent<HTMLSpanElement>) => {
      if (e.currentTarget) {
        const tableHeadCell = e.currentTarget.parentElement as HTMLTableHeaderCellElement | null;
        return tableHeadCell && setTargetSetNotes(tableHeadCell.cellIndex);
      }
    };

    const setHeads = () => {
      const scoreCount = exercise.score_count;
      let heads: JSX.Element[] = scoreCount
        ? []
        : [
            // <th key={0}>
            //   {1}
            //   <span className='info-icon' onClick={handleSetNotes}>
            //     <img src={ic_info} alt={t('notes')} title={t('Set 1 Notes')} />
            //   </span>
            //   <span
            //           className='del-icon'
            //           onClick={handleRemCol}
            //         >
            //           <img
            //             src={ic_del}
            //             alt={t('delete')}
            //             title={t(`Remove Set 1`)}
            //           />
            //         </span>
            // </th>,
          ];
      if (scoreCount) {
        for (let i = 0; i < scoreCount; i++) {
          heads.push(
            <th key={i + 1}>
              {i + 1}
              {i >= 0 ? (
                <>
                  <span className="info-icon" onClick={handleSetNotes}>
                    <img
                      src={ic_info}
                      alt={t("notes")}
                      // title={t(`Set ${i + 1} Notes`)}
                    />
                  </span>
                  <span className="del-icon" onClick={handleRemCol}>
                    <img
                      src={ic_del}
                      alt={t("delete")}
                      // title={t(`Remove Set ${i + 1}`)}
                    />
                  </span>
                </>
              ) : (
                <span className="info-icon" onClick={() => setTargetSetNotes(i + 1)}>
                  <img
                    src={ic_info}
                    alt={t("notes")}
                    // title={t(`Set ${i + 1} Notes`)}
                  />
                </span>
              )}
            </th>
          );
        }
      }
      return heads;
    };
    if (!tableHead) {
      return setTableHead(
        <tr>
          <th>{t("Sets")}</th>
          {setHeads()}
        </tr>
      );
    }
  }, [tableHead, exercise, ic_del, ic_info, t]);
  // Generate BodyRow
  const generateBodyRow = React.useCallback(() => {
    // toggle option select
    const toggleOptions = (e: React.ChangeEvent<HTMLInputElement>) => {
      e.preventDefault();
      const currentTargetValue = e.currentTarget.value;
      const currentTargetDataCell = e.currentTarget
        .parentElement as HTMLTableDataCellElement | null;
      const currentTargetRow =
        currentTargetDataCell &&
        (currentTargetDataCell.parentElement as HTMLTableRowElement | null);
      const selectDataCell =
        currentTargetRow && (currentTargetRow.firstElementChild as HTMLTableDataCellElement | null);

      const selectInput =
        selectDataCell && (selectDataCell.firstElementChild as HTMLSelectElement | null);

      if (!selectInput) {
        // TODO: fix (and add a gui test!) this (obviously broken) error handling
        const error: any = new Error();
        error.error_code = 504;
        error.error_message = t("Input not found");
        error.title = t("App Error!");
        throw error;
      }

      if (currentTargetValue === "") return selectInput.removeAttribute("disabled");
      if (selectInput.disabled) return;
      return selectInput.setAttribute("disabled", "true");
    };
    // set name attribute for corresponding row inputs
    const handleOptions = (e: React.ChangeEvent<HTMLSelectElement>) => {
      e.preventDefault();
      const name = e.currentTarget.value;
      const metric = e.currentTarget.nextElementSibling as HTMLSpanElement | null;
      const currentIndex = parseInt(e.currentTarget.id);
      const targetTable = document.getElementById(`set-table-${currentIndex}`);

      if (e.currentTarget.value === "" || !targetTable) return;

      const targetTableBody = targetTable.children[1].children;

      if (!targetTableBody[0] || !metric) return;

      const targetTableBodyInputs = [
        ...targetTableBody[0].querySelectorAll("input.form-control"),
      ] as HTMLInputElement[];

      targetTableBodyInputs.forEach((v, i) => {
        if (targetTableBodyInputs[i].name !== "notes_sets") {
          targetTableBodyInputs[i].name = name;
          targetTableBodyInputs[i].step = isScoreTypeWithIntegerValues(name) ? "1" : "0.01";
        }
      });
      metric.innerText = generateMetrics(name);
      if (isSchedule) {
        const resultsRow = targetTable.children[1].lastElementChild as HTMLTableRowElement;
        const resultMetric = resultsRow.getElementsByTagName("span")[0];
        if (resultMetric) resultMetric.innerText = generateMetrics(name);
      }
    };
    // Generate options list based on exercise type
    const generateOptionSelect = () => {
      let scoreColumnOptions;
      let length;
      const type = exerciseItem && exerciseItem.type;
      if (!catalog || !type) return;
      if (type.toString() === ExerciseType.CARDIO) {
        scoreColumnOptions = CardioScoreType;
        length = Object.keys(CardioScoreType).length / 2;
      } else {
        scoreColumnOptions = WorkoutScoreType;
        length = Object.keys(WorkoutScoreType).length / 2;
      }
      let options: JSX.Element[] = [];
      for (let i = 0; i < length; i++) {
        options = [
          ...options,
          <option
            key={i}
            value={catalog.typesDisplay(scoreColumnOptions[i])}
            style={{
              textTransform: "none",
            }}
          >
            {catalog.typesDisplay(scoreColumnOptions[i])[0].toUpperCase()}
            {catalog.typesDisplay(scoreColumnOptions[i]).slice(1).toLowerCase()}{" "}
            {generateMetrics(scoreColumnOptions[i]).toLowerCase()}
          </option>,
        ];
      }
      return exercise.score_vals &&
        exercise.score_vals.length > 0 &&
        exercise.score_vals[0].value[0] &&
        exercise.score_vals[0].value.find((el) => el === 0) ? (
        <>
          <select
            disabled
            id={`${index}`}
            name="score_type"
            className="form-control"
            style={{ textTransform: "none", padding: "0px", width: "110px" }}
            onChange={handleOptions}
            defaultValue={exercise.score_type}
          >
            {options}
          </select>
          {/* <span>{generateMetrics(exercise.score_type)}</span> */}
        </>
      ) : (
        <>
          <select
            id={`${index}`}
            name="score_type"
            className="form-control"
            style={{ textTransform: "none", padding: "0px", width: "110px" }}
            onChange={handleOptions}
            defaultValue={exercise.score_type}
          >
            {options}
          </select>
          {/* <span>{generateMetrics(exercise.score_type)}</span> */}
        </>
      );
    };
    // Generate Table Data cells
    const setData = (name: string) => {
      const scoreCount = exercise.score_count;
      const colIndex = exercise.score_cols && exercise.score_cols.findIndex((el) => el === name);
      let dataCells: JSX.Element[] =
        colIndex > -1
          ? [
              <td key={0}>
                <input
                  type="text"
                  className="form-control"
                  name={name}
                  autoComplete="off"
                  // min={0}
                  // step={isInt(name) ? 1 : 0.01}
                  defaultValue={
                    exercise.score_vals &&
                    exercise.score_vals.length > 0 &&
                    exercise.score_vals[colIndex].value[0]
                      ? isScoreTypeWithIntegerValues(name)
                        ? metricConverter(exercise.score_vals[colIndex].value[0], name, metric)
                        : metricConverter(
                            exercise.score_vals[colIndex].value[0],
                            name,
                            metric
                          ).toFixed(2)
                      : undefined
                  }
                  onChange={toggleOptions}
                  onKeyUp={handleInputChange}
                />
                {name === exercise.score_type && (
                  <input
                    type="text"
                    name="notes_sets"
                    className="form-control"
                    defaultValue={exercise.notes_sets[colIndex]}
                    style={{ display: "none" }}
                  />
                )}
              </td>,
            ]
          : [
              <></>,
              // <td key={0}>
              //   <input
              //     type='text'
              //     className='form-control'
              //     name={name}
              //     autoComplete="off"
              //     // min={0}
              //     // step={isInt(name) ? 1 : 0.01}
              //     defaultValue={
              //       exercise.score_vals &&
              //       exercise.score_vals.length > 0 &&
              //       exercise.score_vals[0].value[0]
              //       ? isInt(name)
              //           ? metricConverter(
              //             exercise.score_vals[0].value[0],
              //             name,
              //             metric
              //           )
              //           : metricConverter(
              //             exercise.score_vals[0].value[0],
              //             name,
              //             metric
              //             ).toFixed(2)
              //             : undefined
              //           }
              //           onChange={toggleOptions}
              //           onKeyUp={handleInputChange}
              //   />
              //   <input
              //   autoComplete="off"
              //     type='text'
              //     name='notes_sets'
              //     className='form-control'
              //     defaultValue={
              //       exercise.notes_sets ? exercise.notes_sets[0] : undefined
              //     }
              //     style={{ display: 'none' }}
              //   />
              // </td>,
            ];
      if (scoreCount >= 1) {
        for (let i = 1; i < scoreCount; i++) {
          dataCells = [
            ...dataCells,
            <td key={i}>
              <input
                set-index={i}
                type="text"
                className="form-control"
                name={name}
                autoComplete="off"
                // min={0}
                // step={isInt(name) ? 1 : 0.01}
                onKeyUp={handleInputChange}
                defaultValue={
                  exercise.score_vals &&
                  exercise.score_vals.length > 0 &&
                  exercise.score_vals[colIndex].value[i]
                    ? isScoreTypeWithIntegerValues(name)
                      ? metricConverter(exercise.score_vals[colIndex].value[i], name, metric)
                      : metricConverter(
                          exercise.score_vals[colIndex].value[i],
                          name,
                          metric
                        ).toFixed(2)
                    : undefined
                }
              />
              {name === exercise.score_type && (
                <input
                  type="text"
                  name="notes_sets"
                  className="form-control"
                  defaultValue={exercise.notes_sets[i]}
                  style={{ display: "none" }}
                />
              )}
            </td>,
          ];
        }
      }
      return dataCells;
    };
    if (!tableBody) {
      const exerciseType = exerciseItem.type;
      const scoreType = exercise.score_type;
      const scoreCols = exercise.score_cols;

      // If no score type or no score cols then return template
      if (!scoreType || !scoreCols) {
        // If exercise type is STRENGTH or KETTLEBELLS add KG_WEIGHTS to default template
        if (exerciseType === ExerciseType.STRENGTH) {
          return setTableBody([
            <tr key={0}>
              <td>{generateOptionSelect()}</td>
              {setData("TIME")}
            </tr>,
            <tr key={1}>
              <td>
                <label className="form-label">
                  {t("pause")}
                  <span
                    style={{
                      marginLeft: "4px",
                      textTransform: "lowercase",
                    }}
                  >
                    {generateMetrics(ScoreType[3])}
                  </span>
                </label>
              </td>
              {setData("PAUSE")}
            </tr>,
            <tr key={2}>
              <td>
                <label className="form-label">
                  {t("Weights")}
                  <span
                    style={{
                      // display: 'block',
                      marginLeft: "4px",
                      textTransform: "lowercase",
                    }}
                  >
                    {generateMetrics(ScoreType[4])}
                  </span>
                </label>
              </td>
              {setData(ScoreType[4])}
            </tr>,
          ]);
        }
        // else default template
        return setTableBody([
          <tr key={0}>
            <td>{generateOptionSelect()}</td>
            {setData("TIME")}
          </tr>,
          <tr key={1}>
            <td>
              <label className="form-label">
                {t("pause")}
                <span>{generateMetrics(ScoreType[3])}</span>
              </label>
            </td>
            {setData("PAUSE")}
          </tr>,
        ]);
      }
      if (scoreCols && !exercise.score_vals.length) {
        const exisitingSetData = scoreCols.map((col, i) => {
          return i === 0 ? (
            // if first column then set option return option selector & score type
            <tr key={i}>
              <td>{generateOptionSelect()}</td>
              {/* {setData(col)} */}
            </tr>
          ) : (
            // ...else return label and optional score keys
            <tr key={i}>
              <td>
                <label className="form-label">
                  {catalog.typesDisplay(col).toLowerCase()}
                  <span>{generateMetrics(col)}</span>
                </label>
              </td>
              {/* {setData(col)} */}
            </tr>
          );
        });
        return setTableBody(exisitingSetData);
      }
      // ... else return existing set data
      const exisitingSetData = scoreCols.map((col, i) => {
        return i === 0 ? (
          // if first column then set option return option selector & score type
          <tr key={i}>
            <td>{generateOptionSelect()}</td>
            {setData(col)}
          </tr>
        ) : (
          // ...else return label and optional score keys
          <tr key={i}>
            <td>
              <label className="form-label">
                {catalog.typesDisplay(col).toLowerCase()}
                <span>{generateMetrics(col)}</span>
              </label>
            </td>
            {setData(col)}
          </tr>
        );
      });
      return setTableBody(exisitingSetData);
    }
  }, [t, catalog, index, exercise, exerciseItem, tableBody, metric, generateMetrics, isSchedule]);
  // Generate Results row
  const generateResultsRow = React.useCallback(() => {
    // Generate result columns
    const generateResults = () => {
      const results: JSX.Element[] = [
        <td key={0}>
          <label className="form-label">
            {t("Results")}
            <span>{generateMetrics(exercise.score_type)}</span>
          </label>
        </td>,
      ];
      if (!exercise.score_count) {
        return setResultRow(results);
      }
      for (let i = 1; i <= exercise.score_count; i++) {
        const value = metricConverter(exercise.result_vals[i - 1], exercise.score_type, metric);
        results.push(
          <td key={i}>
            <input
              className="form-control"
              name="result_vals"
              type="text"
              // min={0}
              onKeyUp={handleInputChange}
              // step={isInt(exercise.score_type) ? 0 : 0.01}
              defaultValue={value && value !== 0 ? value : undefined}
            />
          </td>
        );
      }
      return setResultRow(results);
    };
    if (!resultRow && exercise.result_vals && isSchedule) return generateResults();
  }, [exercise, resultRow, isSchedule, metric, generateMetrics, t]);

  // Effects
  React.useEffect(generateHeadRow, [currentTab, generateHeadRow]);
  React.useEffect(generateBodyRow, [currentTab, generateBodyRow]);
  React.useEffect(generateResultsRow, [generateResultsRow, exercise, resultRow, isSchedule]);
  React.useEffect(showConfirmColModal, [showConfirmColModal, targetCol]);
  React.useEffect(showSetNoteModal, [showSetNoteModal, targetSetNotes]);

  if (!exerciseItem || !catalog) return <></>;

  const exerciseType = exerciseItem.type;
  // Generate select input & options:
  const generateOptions = (close: () => void) => {
    let scoreColumnOptions: any;
    let length;
    switch (exerciseType) {
      case ExerciseType.CARDIO:
        scoreColumnOptions = CardioScoreCloumns;
        length = Object.keys(CardioScoreCloumns).length / 2;
        break;
      case ExerciseType.STRENGTH:
        scoreColumnOptions = StrengthScoreColumns;
        length = Object.keys(StrengthScoreColumns).length / 2;
        break;
      default:
        scoreColumnOptions = WorkoutScoreColumns;
        length = Object.keys(WorkoutScoreColumns).length / 2;
        break;
    }
    let options: JSX.Element[] = [
      <li
        key={0}
        value={""}
        style={{ cursor: "pointer", textTransform: "capitalize", color: "var(--gray)" }}
        onClick={handleAddOptions}
      >
        {t("SELECT")}
      </li>,
    ];
    const targetTable = document.querySelector(`#set-table-${index}`);
    const targetTableBody = targetTable && targetTable.children[1];
    const targetFormLabels: any =
      targetTableBody && targetTableBody.querySelectorAll("label.form-label");
    for (let i = 0; i < length; i++) {
      const isActive = [...targetFormLabels].find(
        (el: HTMLLabelElement | any) =>
          el.innerText.replace(generateMetrics(scoreColumnOptions[i]), "").trim().toUpperCase() ===
          catalog.typesDisplay(scoreColumnOptions[i])
      );
      options = [
        ...options,
        <li
          key={i + 1}
          value={catalog.typesDisplay(scoreColumnOptions[i])}
          style={{ cursor: "pointer", textTransform: "capitalize", textAlign: "left" }}
          onClick={handleAddOptions}
        >
          <span className={isActive ? "checkbox active" : "checkbox"} style={{ marginRight: 8 }} />
          {catalog.typesDisplay(scoreColumnOptions[i].toLowerCase())}
        </li>,
      ];
    }
    options = [
      ...options,
      <li key={options.length} style={{ cursor: "pointer", textTransform: "capitalize" }}>
        <button
          type="button"
          className="btn"
          style={{
            width: "100%",
            backgroundColor: "black",
            color: "white",
            padding: ".3rem",
            margin: "10px 0px 0",
          }}
          onClick={() => {
            handleDone();
            close();
          }}
        >
          {t("Done")}
        </button>
      </li>,
    ];
    return <ul style={{ marginBottom: "0" }}>{options}</ul>;
  };
  // Check if add options is required:
  const requireOptions = () => {
    switch (exerciseType) {
      case ExerciseType.CARDIO:
        return true;
      default:
        return false;
    }
  };

  const handleInputChange = (e: any) => {
    let stVal = e.target.value;
    var regex = /^[0-9.,]+$/;
    if (regex.test(e.key)) {
      if (e.key === ".") {
        let dotScore = 0;
        for (let i = 0; i < e.target.value.length; i++) {
          if (e.target.value[i] === ".") {
            dotScore = dotScore + 1;
          }
        }
        if (dotScore > 1) {
          stVal = stVal.slice(0, -1);
          e.target.value = stVal;
        }
      }
      if (e.key === ",") {
        stVal = stVal.slice(0, -1) + ".";
        let dotScore = 0;
        for (let i = 0; i < stVal.length; i++) {
          if (stVal[i] === ".") {
            dotScore = dotScore + 1;
          }
        }
        if (dotScore > 1) {
          stVal = stVal.slice(0, -1);
          return (e.target.value = stVal);
        }
        return (e.target.value = stVal);
      }
    } else {
      stVal = stVal.slice(0, -1);
      e.target.value = stVal;
    }
  };

  // Generate table heads after add set button click
  const generateTableHeads = () => {
    setGenerateTableCount(1 + generateTableCount);
    const newTableHead = document.createElement("th");
    const newTableSpan = document.createElement("span");
    const newTableIcon = document.createElement("img");
    const newTableBody = document.createElement("td");
    const newTableBodyInput = document.createElement("input");
    const newTableNoteSpan = document.createElement("span");
    const newTableNoteIcon = document.createElement("img");
    const newTableBodyNote = document.createElement("input");

    newTableSpan.className = "del-icon";
    // @ts-ignore
    newTableSpan.style.float = "right";
    newTableIcon.src = ic_del;

    newTableBodyInput.className = "form-control";
    newTableBodyInput.type = "text";
    newTableBodyInput.autocomplete = "off";
    newTableBodyInput.id = `newGeneratedInput-${generateTableCount}`;

    newTableNoteSpan.className = "info-icon";
    newTableNoteIcon.src = ic_info;
    newTableBodyNote.style.display = "none";
    newTableBodyNote.className = "form-control";
    newTableBodyNote.type = "text";
    newTableBodyNote.name = "notes_sets";

    const targetTable = document.getElementById(`set-table-${index}`) as HTMLTableElement | null;
    if (!targetTable) return;

    const tableHead = targetTable.children[0]; // <thead/>
    const tableBody = targetTable.children[1]; // <tbody/>
    const tableHeadRow = tableHead.children[0]; // <th/>
    const tableBodyRows = tableBody.children as HTMLCollectionOf<HTMLTableRowElement>; // <tr/>
    const scoreRows = tableBodyRows.length; // Number of scores
    newTableHead.innerHTML = `${tableHeadRow.children.length}`;
    newTableSpan.addEventListener("click", handleRemCol);
    newTableNoteSpan.addEventListener("click", handleSetNotes);
    // Add icon img to span
    newTableSpan.append(newTableIcon);
    newTableNoteSpan.append(newTableNoteIcon);
    // Add new span to th
    newTableHead.append(newTableSpan, newTableNoteSpan);
    // Add new th to table head
    tableHeadRow.append(newTableHead);
    // Generate inputs for each selected option
    for (let i = 0; i < scoreRows; i++) {
      const targetRow = tableBodyRows.item(i) as HTMLTableRowElement;
      newTableBodyInput.value = "";
      if (targetRow && targetRow.cells[targetRow.cells.length - 1]) {
        const prevColInput = targetRow.cells[targetRow.cells.length - 1]
          .firstElementChild as HTMLInputElement | null;
        if (i === 0) {
          const newSelectInput = targetRow.cells[0].firstElementChild as HTMLSelectElement;
          // console.log('val', prevColInput?.id, prevColInput)
          if (prevColInput && prevColInput?.id !== "1") {
            newTableBodyInput.value = Number(prevColInput.value) ? prevColInput.value : "";
          } else {
            newTableBodyInput.value = "";
          }

          newTableBodyInput.name = newSelectInput.value;
          // newTableBodyInput.step = isInt(newSelectInput.value) ? '1' : '0.01';
          newTableBody.append(newTableBodyInput, newTableBodyNote);
        } else if (/Results/.test(targetRow.innerText.trim())) {
          newTableBodyInput.name = "result_vals";
          // newTableBodyInput.step = isInt(`${exercise.score_type}`)
          //   ? '1'
          //   : '0.01';
          newTableBody.append(newTableBodyInput);
        } else {
          // console.log('val2', prevColInput?.id, prevColInput)
          if (prevColInput?.value) {
            newTableBodyInput.value = prevColInput.value;
          } else {
            newTableBodyInput.value = "";
          }

          if (targetRow.innerText.includes("Weights")) {
            newTableBodyInput.name = "KG_WEIGHTS";
          } else if (targetRow.innerText.includes("Pulse Zone")) {
            newTableBodyInput.name = "PULSE_ZONE";
          } else {
            newTableBodyInput.name = targetRow.innerText.split("(")[0].trim().toUpperCase();
          }

          // newTableBodyInput.step = isInt(newTableBodyInput.name) ? '1' : '0.01';
          newTableBody.append(newTableBodyInput);
        }

        targetRow.append(newTableBody.cloneNode(true));
        for (let j = 0; j < newTableBody.children.length; j++) {
          const tableBodyNote = newTableBody.children[j].getAttribute("name");
          if (!tableBodyNote) return;
          if (/notes_sets/.test(tableBodyNote) || /result_vals/.test(tableBodyNote))
            newTableBody.removeChild(newTableBody.children[j]);
        }
      }
    }
    const tableContainer = document.getElementById(
      `table-container-${index}`
    ) as HTMLDivElement | null;
    tableContainer &&
      tableContainer.scrollTo({
        left: targetTable.scrollWidth,
        behavior: "smooth",
      });
    document
      .querySelector(`#newGeneratedInput-${generateTableCount}`)!
      .addEventListener("keyup", handleInputChange);
  };
  // Generate table rows
  const generateTableRows = (label: string) => {
    const targetTable = document.getElementById(`set-table-${index}`) as HTMLTableElement | null;

    if (!targetTable) return;

    const tableHeadRow = targetTable.children[0].children[0] as HTMLTableRowElement;
    const setNumber = tableHeadRow.children.length;
    const tableBody = targetTable.children[1] as HTMLTableRowElement;

    // Check if entry already exists in the table:
    const targetEntry = [...tableBody.children].find((row, i) => {
      const td = row.firstElementChild as HTMLTableDataCellElement;
      if (!td) return false;
      if (i === 0) {
        const selectInput = td.firstElementChild as HTMLSelectElement;
        if (selectInput && selectInput.value === label) return true;
      }
      const labelElement = td.firstElementChild as HTMLLabelElement;
      return (
        labelElement.innerText.replace(generateMetrics(label), "").toUpperCase().trim() === label
      );
    }) as HTMLTableRowElement | undefined;
    // If entry exists & not first row then remove corresponding row:
    if (targetEntry) {
      if (targetEntry.rowIndex > 1) {
        return targetEntry.remove();
      }
      // Prevent adding duplicate rows
      return alert(`${label.toLowerCase()} ${t("already exists")}`);
    }

    // If entry doesn't exist then generate new table row:
    const newTableBodyRow = document.createElement("tr");
    const newTableBodyRowData1 = document.createElement("td");
    const newTableBodyRowData2 = document.createElement("td");
    const newTableBodyRowDataLabel = document.createElement("label");
    const newTableBodyRowDataSpan = document.createElement("span");
    const newTableBodyRowDataInput = document.createElement("input");

    newTableBodyRowDataLabel.className = "form-label";
    newTableBodyRowDataLabel.innerText = label.toLowerCase();
    Object.assign(newTableBodyRowDataLabel.style, {
      textTransform: "capitalize",
      textAlign: "left",
      width: "100%",
    });
    newTableBodyRowDataSpan.innerText = generateMetrics(label);
    Object.assign(newTableBodyRowDataSpan.style, {
      // display: 'block',
      marginLeft: "4px",
      textAlign: "left",
      width: "100%",
      textTransform: "lowercase",
    });
    // newTableBodyRowDataLabel.addEventListener('click', handleRemRow);

    newTableBodyRowDataInput.className = "form-control";
    newTableBodyRowDataInput.name = label;
    newTableBodyRowDataInput.type = "number";
    newTableBodyRowDataInput.min = "0";
    newTableBodyRowDataInput.step = isScoreTypeWithIntegerValues(label) ? "1" : "0.01";

    newTableBodyRowDataInput.addEventListener("invalid", (e) => console.log(e.currentTarget));

    // Append the span element to the new label
    newTableBodyRowDataLabel.append(newTableBodyRowDataSpan);
    // Append the label element to the new td.
    newTableBodyRowData1.append(newTableBodyRowDataLabel);
    // Append the input element to the new td.
    newTableBodyRowData2.append(newTableBodyRowDataInput);
    // Append the new td to the new tr.
    newTableBodyRow.append(newTableBodyRowData1);
    // Append new inputs according to set number.
    for (let i = 1; i < setNumber; i++) {
      const newTableRowData = newTableBodyRowData2.cloneNode(true) as HTMLTableDataCellElement;
      const existingValue =
        exercise.score_vals && exercise.score_vals.find((el) => el.type === label);
      if (existingValue && newTableRowData.children[0])
        newTableRowData.children[0].setAttribute(
          "value",
          JSON.stringify(existingValue.value[i - 1])
        );
      newTableBodyRow.append(newTableRowData);
    }
    // Append the new tr before results row
    if (isSchedule) {
      const resultRow = tableBody.lastChild;
      tableBody.insertBefore(newTableBodyRow, resultRow);
      // Append the new tr to the current table.
    } else {
      tableBody.append(newTableBodyRow);
    }
  };

  // Handle add set click
  const handleAddSet = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    generateTableHeads();
  };
  // Handle options selection
  const handleAddOptions = (e: React.MouseEvent<HTMLLIElement>) => {
    e.preventDefault();
    const label = e.currentTarget.getAttribute("value");
    if (label === "all") {
      // TODO add select all functionality
    }
    const targetCheckBox = e.currentTarget.firstElementChild;
    if (targetCheckBox) targetCheckBox.classList.toggle("active");
    if (!label || label === "") return;
    let labelArray = [...labelState];
    labelArray.push(label);
    setLabelState(labelArray);
  };
  const handleDone = () => {
    if (!labelState.length || labelState[0] === "") return;
    labelState.forEach((v: string) => {
      generateTableRows(v.toUpperCase());
    });
    setLabelState([]);
  };
  return (
    <>
      <div className={`button-group`} style={{ padding: "5px 0px" }}>
        {requireOptions() && (
          <Popup
            trigger={
              <button
                type="button"
                style={{
                  position: "relative",
                  float: "left",
                  textTransform: "none",
                  userSelect: "none",
                  marginTop: 0,
                  marginRight: "4px",
                  width: "137px",
                  fontSize: i18next.language === "dn" ? "12px" : "1rem",
                  height: i18next.language === "dn" ? "38px" : "unset",
                }}
                className="btn btn-primary"
              >
                {t("Add option")}
              </button>
            }
            arrow={true}
            arrowStyle={{ left: "22%" }}
            position={"bottom center"}
            contentStyle={{
              textAlign: "left",
              fontSize: 14,
              maxWidth: "140px",
              minWidth: "100px",
              cursor: "pointer",
              borderRadius: "5px",
              backgroundColor: "var(--white)",
              color: "black",
            }}
          >
            {generateOptions}
          </Popup>
        )}

        <button
          type="button"
          style={{ float: "left", textTransform: "none", marginTop: 0, width: "137px" }}
          className={`btn btn-success ${classes.addSetBtn}`}
          onClick={handleAddSet}
        >
          {t("Add set")}
        </button>
      </div>
      <div id={`table-container-${index}`} className={classes.tableContainer}>
        <Table id={`set-table-${index}`} className={`set-table ${classes.tableToppy}`}>
          <TableHead>{tableHead}</TableHead>
          <TableBody>
            {tableBody}
            {isSchedule && resultRow && <tr>{resultRow}</tr>}
          </TableBody>
        </Table>
      </div>
      <ConfirmCol
        show={showConfirmCol}
        onSubmit={confirmRemCol}
        onHide={() => setTargetCol(null)}
        title={t("Remove Column")}
        message={t("Are you sure you want to remove this column?")}
      />
      <Dialog
        fullWidth
        maxWidth="sm"
        open={showSetNotes}
        onClose={() => setTargetSetNotes(null)}
        className={classes.dialog}
      >
        <DialogTitle>
          {t("Set")} {targetSetNotes} {t("Notes")} <Clear onClick={() => setTargetSetNotes(null)} />
        </DialogTitle>

        <DialogContent>
          <form id="set-note" onSubmit={saveSetNotes}>
            <textarea
              name="notes"
              defaultValue={
                targetSetNotes && exercise.notes_sets
                  ? exercise.notes_sets[targetSetNotes - 1]
                  : undefined
              }
              placeholder={`${t(`Notes`)}`}
              // placeholder={`${t(`Notes`)} for set ${targetSetNotes}`}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" type="submit" form="set-note">
            {t("Save")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
